import React, { Component } from 'react';
import config from './../../common/config';
/**
 * Component that alerts if you click outside of it
 */
export default class OutsideNotifier extends Component {
    constructor(props) {
        super(props);
        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.handleClickOutsideTimeOut = this.handleClickOutsideTimeOut.bind(this);
    }
    componentDidMount() {
        const IOS = config.BrowserDetect.iOS();
        if (!IOS) {
            document.addEventListener('click', this.handleClickOutsideTimeOut);
        }
        else {
            document.addEventListener('touchstart', this.handleClickOutsideTimeOut);
        }
    }

    componentWillUnmount() {
        const IOS = config.BrowserDetect.iOS();
        if (!IOS) {
            document.removeEventListener('click', this.handleClickOutsideTimeOut);
        }
        else {
            document.removeEventListener('touchstart', this.handleClickOutsideTimeOut);
        }
    }

    /**
     * Set the wrapper ref
     */
    setWrapperRef(node) {
        this.wrapperRef = node;
    }

    /**
     * Alert if clicked on outside of element
     */
    handleClickOutside(event) {
        const { ref1 } = this.props;
        this.wrapperRef = ref1.current;
        event.stopPropagation();
        // if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
            this.props.handler && this.props.handler(event);
        }

    }
    handleClickOutsideTimeOut(event) {
        const self = this;
        //event.stopPropagation();
        setTimeout(() => {
            self.handleClickOutside(event);
        }, 100);

    }
    render() {
        const { className, ref1 } = this.props;
        return <div className={className} ref={ref1}>{this.props.children}</div>;
    }
}